module.exports = __webpack_public_path__ + "img/homeArrowInflate.89575283.svg";